module.exports = __webpack_public_path__ + "static/media/wordle_speed_results.ab24c47c.png";